// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

const init = () =>
  Sentry.init({
    dsn: SENTRY_DSN || 'https://48c441e1141d4547af4540730562c65d@o924794.ingest.sentry.io/5873171',
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0, // TODO: Use SENTRY_CLIENT_TRACE_SAMPLE_RATE environment variable to control this value
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
  })
